exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shortcuts-row[data-v-5e06fd66]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.shortcuts-inner[data-v-5e06fd66]{background:#fff;padding:10px 15px;border:1px solid #ddd}.shortcuts-inner a[data-v-5e06fd66]{text-decoration:none}.shortcuts-inner a[data-v-5e06fd66]:hover{text-decoration:underline}", ""]);

// exports
